module.exports = __webpack_public_path__ + "img/MultiColorIcon.6996120a.svg";